import { CircularProgress } from '@material-ui/core'

const Loader = () => {
  return <CircularProgress className="loader" />
}

export default Loader
